import type { ComponentPropsWithoutRef } from "react";
import { tv } from "tailwind-variants";

const errorMessageVariants = tv({
  base: "block px-2 pt-1.5 text-left text-sm font-medium text-danger",
});

export type FormErrorType = string | boolean;

export type ErrorMessageProps = {
  error?: FormErrorType;
} & ComponentPropsWithoutRef<"p">;

export const ErrorMessage = ({ className, error, ...props }: ErrorMessageProps) => {
  if (!error) {
    return null;
  }

  return (
    <p className={errorMessageVariants({ className })} role="alert" {...props}>
      {error}
    </p>
  );
};
